<script lang="ts">
	import { PrimaryRoutes } from '#lib/websites/primary/constants/routes.js';
	import type { GetPrimaryGalleryArtworksQuery } from '#lib/websites/primary/queries/__generated__/getPrimaryGalleryArtworks.generated.js';
	import { ArtworkCard } from '$global/components/ArtworkCard';
	import { getImageUrl } from '$global/utils/getImageUrl/getImageUrl';

	interface Props {
		artwork: GetPrimaryGalleryArtworksQuery['Primary_Artworks'][0];
		slug: string;
		dataCy: string;
		onclick?: () => void;
	}

	let { artwork, slug, dataCy, onclick = undefined }: Props = $props();
</script>

<ArtworkCard
	{dataCy}
	onClick={onclick}
	line1={`${artwork.artists?.map((artist) => artist?.Artists_id?.name)?.join(', ')}`}
	line2={artwork.artwork_title || ''}
	line3={artwork.artwork_code || ''}
	href={`${PrimaryRoutes.Collection}/${slug}/artwork/${artwork.slug}`}
	image={{
		width: artwork.artwork_featured_image?.width || 0,
		height: artwork.artwork_featured_image?.height || 0,
		url:
			getImageUrl(artwork.artwork_featured_image?.filename_disk, '512px') || '',
	}}
	alt={`${artwork.artwork_title} ${artwork.artwork_code}`}
/>
